import React, {useEffect, useState} from "react";
import {getJSON, page, TimeBar} from "./ui";
import {ZedSays} from "./zed";

// Brief per-player reveal between guessing and the leaderboard. Shows the actual
// points earned this round (guess + your drawing), so it matches the board.
export const RevealPhase = ({state, offset}) => {
    const [data, setData] = useState(null);
    useEffect(() => {
        let live = true;
        const tick = () => getJSON('/demo/my-result').then(d => { if (live && d) setData(d); });
        tick();
        const id = setInterval(tick, 800);
        return () => { live = false; clearInterval(id); };
    }, [state.round]);

    const ready = data
        && (data.results || []).every(r => r.scored)
        && (!data.drawing || data.drawing.scored);

    const g = ready && data.results && data.results[0];
    return <div style={{...page, justifyContent: 'space-evenly', gap: 0}}>
        {state.phase_ends_at && <TimeBar endsAt={state.phase_ends_at} offset={offset} total={10000} calm />}
        <ZedSays line={g ? `It was ${g.word}. ${g.reaction || ''}`.trim() : 'Judging your guess.'} />
        {ready ? <Result data={data} /> : <div style={{height: 200}} />}
    </div>;
};

const label = {fontSize: 14, letterSpacing: 3, textTransform: 'uppercase', opacity: 0.55, fontWeight: 700};
const big = {fontSize: 38, fontWeight: 900, lineHeight: 1.1};

const Result = ({data}) => {
    const [shown, setShown] = useState(false);
    useEffect(() => { const t = setTimeout(() => setShown(true), 80); return () => clearTimeout(t); }, []);

    const g = (data.results && data.results[0]) || {};
    const guessPts = (data.results || []).reduce((s, r) => s + (r.score || 0), 0);
    const drawPts = Math.max(0, (data.round_points || 0) - guessPts);

    return <div style={{
        width: '100%', textAlign: 'center',
        opacity: shown ? 1 : 0, transform: shown ? 'scale(1)' : 'scale(0.85)',
        transition: 'opacity 400ms ease, transform 400ms cubic-bezier(0.2,0.9,0.2,1.3)',
    }}>
        <div style={label}>You Guessed</div>
        <div style={{...big, marginBottom: 14}}>{g.guess || '—'}</div>

        <div style={{fontSize: 64, fontWeight: 900, color: '#f1d28b', textShadow: '0 0 20px #f1d28baa'}}>
            +{data.round_points}<span style={{fontSize: 22, opacity: 0.8}}> pts</span>
        </div>
        <div style={{...label, marginTop: 2}}>this round</div>

        <div style={{marginTop: 16, fontSize: 16, opacity: 0.9}}>
            Guessing <strong>+{guessPts}</strong>
            {data.drawing && <> · Your drawing <strong>+{drawPts}</strong></>}
        </div>
        {data.drawing && data.drawing.guessed && (
            <div style={{marginTop: 6, fontSize: 13, opacity: 0.6}}>
                your <span style={{textTransform: 'capitalize'}}>{data.drawing.word}</span> was guessed “{data.drawing.guessed}”
            </div>
        )}
    </div>;
};
